export function sliderValueToVideoTime(duration, sliderValue) {
    return Math.round(duration * sliderValue / 100)
}

export function VideoTimeTosliderValue(duration, videoTime) {
    // console.log(duration)
    // console.log(videoTime)
    // console.log(Math.round((videoTime / duration) * 100))
    return Math.round(videoTime / duration * 100)
}